import Lottie from "lottie-react-native";

export { Lottie };
